var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgC1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 8,
    fill: "#DCFAF8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95,
    clipPath: "url(#clip0_1621_80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 11.2499V13.8299H7V11.2499C7 9.83561 8.15714 8.67847 9.57143 8.67847H12.5714V11.2156C12.5714 11.687 12.9571 12.0728 13.4286 12.0728C13.9 12.0728 14.2857 11.687 14.2857 11.2156V8.67847H23.7143V11.2156C23.7143 11.687 24.1 12.0728 24.5714 12.0728C25.0429 12.0728 25.4286 11.687 25.4286 11.2156V8.67847H28.4286C29.8429 8.67847 31 9.83561 31 11.2499ZM24.1429 24.1242H30.4771L23.2857 30.5356V24.9813C23.2857 24.5099 23.6714 24.1242 24.1429 24.1242Z",
    fill: "#42BFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 15.5457V22.4114H24.1429C22.7286 22.4114 21.5714 23.5686 21.5714 24.9829V31H9.57143C8.15714 31 7 29.8429 7 28.4286V15.5457H31ZM14.2857 7.85714V8.68H12.5714V7.85714C12.5714 7.38571 12.9571 7 13.4286 7C13.9 7 14.2857 7.38571 14.2857 7.85714ZM25.4286 7.85714V8.68H23.7143V7.85714C23.7143 7.38571 24.1 7 24.5714 7C25.0429 7 25.4286 7.38571 25.4286 7.85714Z",
    fill: "#42BFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7725 19.1797L14.4053 22.7461L16.0381 19.1797H17.7944L15.2217 24.1533V27H13.5889V24.1533L11.0107 19.1797H12.7725Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1621_80"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC1);
export default __webpack_public_path__ + "static/media/c1.e91564e1c1d6b329f5cd1b6f062da5d5.svg";
export { ForwardRef as ReactComponent };